<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <home-banner :list="banner1" />

    <div class="main1">
      <div class="container">
        <div class="sub-title">
          协会公告
          <span class="mouse" @click="$router.push('/notice?type=1')">全部</span>
        </div>

        <div class="main-container pt24">
          <div class="w50" v-if="banner2.length">
            <swiper class="swipe-news" ref="newsSwiper" :options="newsSwiperOptions">
              <swiper-slide v-for="item in banner2" :key="item.id" class="swipe-news-item">
                <img :class="{'mouse': item.jumpUrl}" @click="jumpUrl(item)" :src="item.picUrl" width="100%" height="364" :alt="item.name" />
                <p><span :class="{'mouse': item.jumpUrl}" @click="jumpUrl(item)">{{ item.name }}</span></p>
              </swiper-slide>
              <div class="news-swiper-pagination" slot="pagination">
                <span v-for="(item, index) in banner2" :key="item.id">{{ index + 1}}</span>
              </div>
            </swiper>
          </div>
          <div class="w50">
            <div class="list-1">
              <dl v-for="item in list1" :key="item.id">
                <dt>
                  <h3>{{ item.createTime | filterDay }}</h3>
                  <p>{{ item.createTime | filterYearM }}</p>
                </dt>
                <dd>
                  <h3 @click="$router.push(`notice/detail?id=${item.type}-${item.subType}-${item.id}`)">{{computedType(item.type, item.subType)}}{{ item.title }}</h3>
                  <p>
                    {{ item.introduction }}
                  </p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="main-container pt12" style="padding-bottom: 32px;">
        <div class="w50_2">
          <div class="sub-title">
            大众排球
            <span class="mouse" @click="$router.push('/volleyball?type=41')">全部</span>
          </div>
          <div class="list-2">
            <dl>
              <dt v-if="banner3.length">
                <img @click="jumpUrl(banner3[0])" :src="banner3[0].picUrl" class="b1" height="300" width="100%" :alt="banner3[0].name" />
              </dt>
              <dd class="mouse" v-for="item in list2" @click="$router.push(`/volleyball/detail?id=${item.type}-${item.subType}-${item.id}`)" :key="item.id">
                <div class="title">{{computedType2(item.type, item.subType)}}{{ item.title }}</div>
                <div class="time">
                  {{ item.createTime ? formatDate(Date.parse(item.createTime), 'YYYY-mm-dd') : '' }}
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="w50_2">
          <div class="sub-title">
            新闻资讯
            <span class="mouse" @click="$router.push('/news?type=2')">全部</span>
          </div>
          <div class="list-2">
            <dl>
              <dt v-if="banner4.length">
                <img @click="jumpUrl(banner4[0])" :src="banner4[0].picUrl" class="b1" width="100%" height="300" :alt="banner4[0].name" />
              </dt>
              <dd class="mouse" v-for="item in list3"  @click="$router.push(`/news/detail?id=${item.type}-${item.subType}-${item.id}`)" :key="item.id">
                <div class="title">{{computedType(item.type, item.subType)}}{{ item.title }}</div>
                <div class="time">
                  {{ item.createTime ? formatDate(Date.parse(item.createTime), 'YYYY-mm-dd') : '' }}
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- <div class="main-container pt12">
        <div class="w50_2">
          <div class="sub-title">
            排球俱乐部
            <span class="mouse">全部</span>
          </div>
          <div class="list-2">
            <dl>
              <dt v-if="banner5.length">
                <img @click="jumpUrl(banner5[0])" :src="banner5[0].picUrl" width="100%" :alt="banner5[0].name" />
              </dt>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛 <i><img src="../../../../assets/images/new.png" alt="new"></i></div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="w50_2">
          <div class="sub-title">
            会员专区
            <span class="mouse">全部</span>
          </div>
          <div class="list-2">
            <dl>
              <dt v-if="banner6.length">
                <img @click="jumpUrl(banner6[0])" :src="banner6[0].picUrl" width="100%" :alt="banner6[0].name" />
              </dt>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛 <i><img src="../../../../assets/images/new.png" alt="new"></i></div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
              <dd>
                <div class="title">五星体育"星辰大海杯"排球公开赛</div>
                <div class="time">2021.11.19</div>
              </dd>
            </dl>
          </div>
        </div>
      </div> -->
      <div class="pt12">
        <div class="sub-title">
          合作单位 <em>Cooperation</em>
        </div>
        <home-cooperation />
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import HomeBanner from '../../sections/home-banner.vue'
import HomeCooperation from '../../sections/home-cooperation.vue'
import { getBanner } from '@/service/apis/common'
import { getNewsPage } from '@/service/apis/news'
import { wenzhang, singlePages } from '@/page/constants'

export default {
  components: {
    Swiper,
    SwiperSlide,
    XhHeader,
    XhFooter,
    HomeBanner,
    HomeCooperation
  },
  data() {
    return {
      banner1: [],
      banner2: [],
      banner3: [],
      banner4: [],
      banner5: [],
      banner6: [],
      newsSwiperOptions: {
        autoplay: true,
        loop: true,
        loopedSlides: 3,
        pagination: {
          el: '.news-swiper-pagination',
          clickable: true
        }
      },
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: []
    }
  },
  filters: {
    filterDay (date) {
      if (date) {
        let d = new Date(date)
        return d.getDate()
      }
      return ''
    },
    filterYearM (date) {
      if (date) {
        let d = new Date(date)
        let m = (d.getMonth() + 1)
        // return d.getFullYear() + '-' + (m < 10 ? `0${m}` :)
        return `${d.getFullYear()}-${ m < 10 ? '0' + m : m}`
      }
      return ''
    }
  },
  created () {
    getBanner(this).then(data => {
      // 首页banner 1
      this.banner1 = [...data[1]]
      // 首页协会公告轮播图
      this.banner2 = [...data[2]]
      this.banner3 = [...data[3]]
      this.banner4 = [...data[4]]
      this.banner5 = [...data[5]]
      this.banner6 = [...data[6]]
    })
    this.getList(1, null, 'list1') // 赛程公告
    this.getList(41, null, 'list2') // 活动信息
    this.getList(2, null, 'list3') // 新闻资讯
    // this.getList(1, 11, 'list4')
    // this.getList(1, 11, 'list5')
  },
  methods: {
    computedType (type, subType) {
      if (type) {
        let findType = wenzhang.find(item => item.id === parseInt(type))
        if (findType) {
          if (subType) {
            let subTypeFind = findType.children.find(item => item.id === parseInt(subType))
            return subTypeFind ? `【${subTypeFind.name}】` : `【${findType.name}】`
          } else {
            return `【${findType.name}】`
          }
        }
        return ''
      } else {
        return ''
      }
    },
    computedType2 (type, subType) {
      let types = singlePages[1]
      if (subType) {
        let findSubType = types.children.find(item => item.id === parseInt(subType))
        return findSubType ? `【${findSubType.name}】` : `【${types.name}】`
      } else {
        return `【${types.name}】`
      }
      // let findType = wenzhang.find(item => item.id === parseInt(type))
      // if (findType) {
      //   if (subType) {
      //     let subTypeFind = findType.children.find(item => item.id === parseInt(subType))
      //     return subTypeFind ? `【${subTypeFind.name}】` : `【${findType.name}】`
      //   } else {
      //     return `【${findType.name}】`
      //   }
      // }
      // return ''
    },
    getList (type, subType, list) {
      let opt = {
        pageIndex: 1,
        pageSize: 4,
        type
      }
      if (subType) {
        opt.subType = subType
      }

      getNewsPage.call(this, opt).then(res => {
        let data = res.data

        this[list] = []
        if (data.records && data.records.length) {
          data.records.forEach(item => {
            this[list].push(item)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.mouse { cursor: pointer; }
.pt24 { padding-top: 24px; }
.pt12 { padding-top: 12px; }

.main1 {
  padding: 15px 12px 24px 12px;
  background-color: #f9faff;
}

.container {
  max-width: 1280px;
  padding: 0 12px;
  margin: 0 auto;
}

.sub-title {
  font-size: 24px;
  line-height: 56px;
  height: 56px;
  margin-bottom: 2px;
  border-bottom: solid 1px #999;
}
.sub-title em {
  font-style: normal;
  color: #999;
}
.sub-title .mouse:hover {
  color: #4c2ac9;
}
.sub-title span {
  text-align: right;
  font-size: 16px;
  color: #4c4c4c;
  width: 120px;
  position: relative;
  display: block;
  float: right;
}
.sub-title span::after {
  position: absolute;
  height: 5px;
  width: 100%;
  right: 0;
  content: '';
  bottom: -2px;
  background-color: #999;
  border-radius: 2px;
}

.main-container {
  height: auto;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.main-container .w50 {
  width: calc((100% - 20px) / 2);
}

.swipe-news-item {
  position: relative;
}
.swipe-news-item p {
  position: absolute;
  color: #fff;
  width: 100%;
  padding: 0 12px;
  padding-right: 60px;
  box-sizing: border-box;
  height: 50px;
  line-height: 50px;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
}
.swipe-news .mouse {
  display: inline-block;
}
.swipe-news .mouse:hover {
  color: #4c2ac9;
}
.news-swiper-pagination {
  padding-right: 12px;
  box-sizing: border-box;
  position: absolute;
  bottom: 20px;
  left: auto;
  right: 0;
  width: 200px;
  text-align: right;
  z-index: 10;
}

.news-swiper-pagination ::v-deep .swiper-pagination-bullet {
  opacity: 0.8;
  background-color: #fff;
}

.news-swiper-pagination ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #4c2ac9;
}

/*  */
.list-1 dl {
  height: 62px;
  padding: 12px 16px;
  display: block;
  background-color: #fff;
  margin-bottom: 8px;
}
.list-1 dl:last-child {
  margin-bottom: 0;
}

.list-1 dl dt {
  float: left;
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 62px;
  height: 62px;
  background-color: #3f3f3f;
}
.list-1 dl dd:hover {
  cursor: pointer;
}

.list-1 dl dt:hover h3 {
  color: #4c2ac9;
}

.list-1 dl dt h3 { font-size: 24px; padding-top: 12px }
.list-1 dl dd {
  width: calc(100% - 74px);
  float: right;
}

.list-1 dl dd h3 {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  font-size: 16px;
  color: #333;
  line-height: 22px;
}
.list-1 dl dd p {
  line-height: 20px;
  font-size: 12px;
  color: #999;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient:vertical;
}
.w50_2 {
  width: calc((100% - 44px) / 2);
}
.list-2 dl { display: block; padding-top: 12px; background-color: #f9faff; }
.list-2 dt {
  margin-bottom: 8px;
}
.list-2 dl dd {
  display: flex;
  justify-content: space-between;
}

.list-2 dl dd:hover .title{
  color: #4c2ac9;
}

.list-2 dl dd { line-height: 42px; padding: 0 16px 0 8px; }
.list-2 dl dd:last-child {
  padding-bottom: 8px;
}
.list-2 dl dd .title {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  width: calc(100% - 180px);
  font-size: 16px;
  color: #333;
}
.list-2 dl dd .time {
  text-align: right;
  width: 80px;
  font-size: 12px;
  color: #808080;
}

@media screen and (max-width: 736px) {
  .main1 {
    padding: 12px 0;
  }
  .main-container .w50,
  .w50_2 {
    width: 100%;
  }
  .sub-title .label {
    display: none;
  }
}
.b1 {
  object-fit: cover;
}
</style>
